export var EField;
(function (EField) {
    EField["PhoneOrEmail"] = "phoneOrEmail";
    EField["Captcha"] = "captcha";
})(EField || (EField = {}));
